import React from "react";
import {
  Table,
} from "reactstrap";
import FaceRecognitionAwsReportModel from "../../../../utils/models/FaceRecognitionAwsReportModel";
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";

export default function GuestsList({
  guestsList = [],
  loading = false,
}) {
  return (
    <div style={{ paddingBottom: '10px' }}>
      <div className="table-responsive">
        <Table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th>ID</th>
              <th>Nome</th>
              <th>E-mail</th>
              <th>Possui Face ID?</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <LoadingSkelentonTable lines={10} cols={4} />
            ) : (
              guestsList.map((s, i) => renderRow(i, s))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )

  function renderRow(index = 0, guest = FaceRecognitionAwsReportModel()) {
    return (
      <tr key={index}>
        <td>{guest.id}</td>
        <td>{guest.name}</td>
        <td>{guest.email}</td>
        <td>
          {guest.hasFace ? (
            <>
              <i className="bx bx-check-circle me-1" style={{ color: "#34c38f", fontSize: 16 }} />
              Sim
            </>
          ) : (
            <>
              <i className="bx bx-x-circle me-1" style={{ color: "#f46a6a", fontSize: 16 }} />
              Não
            </>
          )}
        </td>
      </tr>
    )
  }
}
